import React from 'react';

export default function AmbientLighting() {
  return (
    <>
      {/* Deep Space Ambient Fill */}
      <ambientLight intensity={0.4} color="#cad5e2" />

      {/* Main Distant Sun Light — creates dramatic day/night terminator on planets */}
      <directionalLight position={[30, 20, 40]} intensity={1.8} color="#fffbf0" />
      <directionalLight position={[-30, -10, -50]} intensity={0.5} color="#38bdf8" />

      {/* Localized Atmosphere Point Lights for Planetary Realism */}
      <pointLight position={[5.5, 3, 55]} intensity={1.2} color="#60a5fa" distance={25} />
      <pointLight position={[-5.5, 3, 26]} intensity={1.2} color="#fb923c" distance={25} />
      <pointLight position={[6.5, 3, -2]} intensity={1.5} color="#fde047" distance={30} />
      <pointLight position={[-5.5, 3, -33]} intensity={1.2} color="#38bdf8" distance={25} />
      <pointLight position={[5.5, 3, -62]} intensity={1.4} color="#ef4444" distance={25} />
      <pointLight position={[-5.5, 3, -92]} intensity={1.4} color="#c084fc" distance={25} />
      <pointLight position={[0, 0, -120]} intensity={2.5} color="#43DDD0" distance={40} />
    </>
  );
}
